import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ILoggerNoiseHistogram } from '@app/api/interfaces/chart-data/logger-noise-histogram';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoiseHistogramState {
  currentTab: FpLoggerNoiseTabs.Histogram;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: ILoggerNoiseHistogram[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoiseHistogramState: IFpLoggerNoiseHistogramState = {
  currentTab: FpLoggerNoiseTabs.Histogram,
  date: null,
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
